import React, { Component } from "react";
// react plugin that creates an input with badges
import {globals,event_form, require} from '../Components/Globals/Globals'
import {useSelector, useDispatch } from 'react-redux';
import { closeModalEvent } from '../redux/modalSlice'; 
import { updateEvent, addEvent } from '../redux/eventSlice';
import {Button, Container } from "reactstrap";
import { openModal } from "../redux/modalSlice";

// core components
import {DsDynamicForm} from "datasync-dynamic-form";
import "../Components/Modal/Modal.css";

const EventFormDialog = () => {
  const {eventModal} = useSelector((state) => state.modal);
  const dispatch = useDispatch();
  const {isAdmin, event_guid, event_email} = useSelector((state) => state.auth);
  const {isReadOnly} = useSelector((state) => state.modal);

  React.useEffect(() => {
    return function cleanup() {
      document.body.classList.remove("discover");
    };
  });

  return (
      <>
        <div className="main modal-overlay">
          <Button className="modal-top-right-close-button" onClick={()=>{dispatch(closeModalEvent())}}>Fermer</Button>
          <div className="modal-container">
            <Container>
              {eventModal.activeObject &&
              <h1>{eventModal.activeObject.data_blob.data_tier.e_mail}</h1>}
              {eventModal.activeObject===null &&
              <h1>{"<Nouvel évènement>"}</h1>}
              <DsDynamicForm
                datasync_url = {globals.datasync_service.url}
                form = {event_form}
                company_guid = {globals.datasync.thononadvent_company_guid}
                table_guid= {globals.datasync.adv_events_table_guid}
                onFormSaved = {(saved_data) => {dispatch(openModal({title:"Evènement enregistré"})); dispatch(addEvent(saved_data)); dispatch(closeModalEvent());}}
                //Let us update the event
                onFormUpdated = {(updated_data) => {dispatch(openModal({title:"Evènement modifié"})); dispatch(updateEvent(updated_data)); dispatch(closeModalEvent());}}
                onFormFailed = {() => {if (globals.parameters.save_failed_alert) alert("Erreur de sauvegarde de l'évènement :-(")}}
                clearOnSave = {true}
                clearOnUpdate = {true}
                sticky_button = {true}
                custom_button_handler = {() => {dispatch(closeModalEvent())}}
                custom_button_caption = {"Fermer"}
                //---
                datasync_object = {eventModal.activeObject}
                data_blob = {eventModal.activeObject?eventModal.activeObject.data_blob:null}
                show_hidden = {isAdmin}
                read_only = {isReadOnly}
              />
            </Container>
          </div>
        </div>
      </>
    );
  }

export default EventFormDialog;
